// Runs synchronously in <head>, before the first paint: a theme chosen with the switch applies at once,
// the stylesheet learns that script runs (the menu button, reveal on scroll), and which device this is,
// so the install page shows only its steps from the start (data-device; none: every device's steps).
(() => {
  const root = document.documentElement;
  root.classList.add("js");
  try {
    const theme = localStorage.getItem("theme");
    if (theme === "light" || theme === "dark") root.dataset.theme = theme;
  } catch {
    /* storage blocked: follow the system */
  }
  const ua = navigator.userAgent;
  // An iPad asks for the desktop site and says Macintosh; only its touch screen gives it away.
  const ios = /iPhone|iPad|iPod/.test(ua) || (/Macintosh/.test(ua) && navigator.maxTouchPoints > 1);
  const device = ios
    ? "ios"
    : /Android/.test(ua)
      ? "android"
      : /Firefox\//.test(ua)
        ? "firefox"
        : /Chrome\/|Edg\//.test(ua)
          ? "chromium"
          : /Macintosh.*Safari\//.test(ua)
            ? "safari"
            : "";
  if (device) root.dataset.device = device;
})();
